import React from "react";
import { Navigate } from "react-router-dom";
import { linkToHome } from "./links";

const NavigateHome: FC<Omit<React.ComponentProps<typeof Navigate>, "to">> = (
  delegateProps,
) => {
  return <Navigate to={linkToHome()} {...delegateProps} />;
};

export default NavigateHome;
